import { Loader } from '@googlemaps/js-api-loader';

export const loader = new Loader({
  apiKey: process.env.GCP_API_KEY,
  version: 'quarterly',
});
